module.exports = __webpack_public_path__ + "img/calendar-minus.94cee521.svg";